import { createStore, useStore } from 'zustand';

import { Order } from '@lib/types';
import { fetchHistoryOrderDetails } from '@lib/api';
import { logger } from '@lib/logger';

import { fromHistoryOrderToOrder } from './fromHistoryOrderToOrder';

interface HistoryOrderStateStore {
  loading: boolean;
  error: Error | null;
  order: Order | null;
  fetch: (orderUUID: string) => Promise<void>;
}

export const historyOrderDetailsStore = createStore<HistoryOrderStateStore>(
  (set) => ({
    order: null,
    error: null,
    loading: false,
    fetch: async (orderUUID: string) => {
      try {
        set({ loading: true });
        const response = await fetchHistoryOrderDetails(orderUUID);
        const order = await fromHistoryOrderToOrder(response);
        set({ order });
      } catch (error) {
        logger.error(error);
        set({ error: error as Error });
      } finally {
        set({ loading: false });
      }
    },
  }),
);

export const useHistoryOrderDetailsStore = () =>
  useStore(historyOrderDetailsStore);
